import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { environment } from '@environements';
import { of } from 'rxjs';
import { Telemetry, SendCommandPayload } from '@telemetry/interfaces/telemetry.interface';

export type {
  TelemetryGetAllByListingIdParams,
  Telemetry,
  SendCommandPayload,
} from '@telemetry/interfaces/telemetry.interface';
export { CSE_SERVER_COMMAND } from '@telemetry/interfaces/telemetry.interface';

@Service()
export class TelemetryService {
  http = inject(HttpClient);

  getAllByListingId(deviceId: string | undefined, params: Date[]) {
    if (deviceId) {
      return this.http.get<Telemetry[]>(`${environment.SAAS_SERVICE}/telemetry/${deviceId}`, {
        params: { startAt: params[0].toISOString(), endAt: params[1].toISOString() },
      });
    }
    return of([]);
  }

  getLatest(deviceId: string) {
    if (deviceId) {
      return this.http.get<Telemetry>(`${environment.SAAS_SERVICE}/telemetry/${deviceId}/latest`);
    }
    return of(undefined);
  }

  sendCommand(payload: SendCommandPayload) {
    return this.http.post(`${environment.SAAS_SERVICE}/cse/command`, payload);
  }
}
